import { PartialPick } from "../../../../constants";
import { RootState } from "../../../../models";
import { ShopAvailabilityState, Shops } from "../../../../models/state";

export type State = PartialPick<RootState, "shopAvailability">;
export const getShopAvailability: (state: State) => Partial<ShopAvailabilityState> = (state) =>
    state.shopAvailability || {};
export const getShops: (state: State) => Shops = (state) => getShopAvailability(state)?.shops || {};
